(function () {
  function initSlider(slider) {
    if (slider.dataset.announcementSliderReady === 'true') return;
    slider.dataset.announcementSliderReady = 'true';
    var sectionId = slider.dataset.sectionId;

    var slides = slider.querySelectorAll('.announcement-slide-' + sectionId);
    if (slides.length < 2) return;

    var prevBtn = slider.querySelector('.announcement-nav-prev-' + sectionId);
    var nextBtn = slider.querySelector('.announcement-nav-next-' + sectionId);

    var slideDuration = parseInt(slider.dataset.slideDuration) || 4000;
    var transitionSpeed = parseInt(slider.dataset.transitionSpeed) || 500;
    var currentIndex = 0;
    var pendingCleanup = null;
    var autoPlayTimer = null;

    function finalizeInFlight() {
        if (pendingCleanup === null) return;
        clearTimeout(pendingCleanup);
        pendingCleanup = null;
        slides.forEach(function (slide) {
            slide.style.transition = 'none';
            slide.classList.remove('entering', 'exiting');
        });
        slider.classList.remove('is-prev');
        slider.offsetHeight;
        slides.forEach(function (slide) {
            slide.style.transition = '';
        });
    }

    function goToSlide(targetIndex, backward) {
        if (targetIndex === currentIndex) return;

        finalizeInFlight();

        if (backward) {
            slider.classList.add('is-prev');
        } else {
            slider.classList.remove('is-prev');
        }

        var outgoing = slides[currentIndex];
        var incoming = slides[targetIndex];

        incoming.classList.add('entering');
        incoming.offsetHeight;

        outgoing.classList.remove('active');
        outgoing.classList.add('exiting');
        incoming.classList.remove('entering');
        incoming.classList.add('active');

        currentIndex = targetIndex;

        pendingCleanup = setTimeout(function () {
            outgoing.classList.remove('exiting');
            slider.classList.remove('is-prev');
            pendingCleanup = null;
        }, transitionSpeed + 50);
    }

    function nextSlide() {
        goToSlide((currentIndex + 1) % slides.length, false);
    }

    function prevSlide() {
        goToSlide((currentIndex - 1 + slides.length) % slides.length, true);
    }

    function resetAutoPlay() {
        if (autoPlayTimer) clearInterval(autoPlayTimer);
        autoPlayTimer = null;
        if (slideDuration > 0) {
            autoPlayTimer = setInterval(nextSlide, slideDuration);
        }
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
            e.preventDefault();
            prevSlide();
            resetAutoPlay();
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            nextSlide();
            resetAutoPlay();
        });
    }

    resetAutoPlay();
  }

  function initAll() {
    document.querySelectorAll('.announcement-slider[data-section-id]').forEach(initSlider);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
